/**
 * ProcessElement API Client
 * Handles all API calls for ProcessElement entities
 */

import { BaseApiClient, ApiResponse } from './baseApiClient';
import { API_ENDPOINTS } from '../config/apiEndpoints';
import {
  ProcessElement,
  CreateProcessElementRequest,
  UpdateProcessElementRequest,
  StandardListRequest,
  GetByIdRequest,
  DeleteRequest,
  SearchRequest,
} from '../types';

export class ProcessElementApiClient extends BaseApiClient {

  async getAll(request: StandardListRequest = {}): Promise<ApiResponse<ProcessElement[]>> {
    return this.postQuery<ProcessElement[]>(API_ENDPOINTS.PROCESS_ELEMENTS.LIST, request);
  }

  async getById(request: GetByIdRequest): Promise<ApiResponse<ProcessElement>> {
    return this.postQuery<ProcessElement>(API_ENDPOINTS.PROCESS_ELEMENTS.GET_BY_ID, { ID: { ID: request.id, ResID: '' } });
  }

  async create(request: CreateProcessElementRequest): Promise<ApiResponse<ProcessElement>> {
    return this.post<ProcessElement>(API_ENDPOINTS.PROCESS_ELEMENTS.CREATE, request);
  }

  async update(request: UpdateProcessElementRequest): Promise<ApiResponse<ProcessElement>> {
    // C# API expects the full entity including ProcessElementID in the body
    // The controller validates that the ID in the body matches the ID in the route
    return this.put<ProcessElement>(API_ENDPOINTS.PROCESS_ELEMENTS.UPDATE(request.ProcessElementID), request);
  }

  async deleteProcessElement(request: DeleteRequest): Promise<ApiResponse<void>> {
    // C# API expects DeleteWebRequest with ID property
    const deleteRequestBody = {
      ID: {
        ID: request.id,
        ResID: '',
      },
    };
    return super.delete<void>(API_ENDPOINTS.PROCESS_ELEMENTS.DELETE(request.id), deleteRequestBody);
  }

  async getByThreadVersion(versionId: number, request: SearchRequest = {}): Promise<ApiResponse<ProcessElement[]>> {
    return this.postQuery<ProcessElement[]>(API_ENDPOINTS.PROCESS_ELEMENTS.BY_THREAD_VERSION, {
      ...request,
      ProcessThreadVersionID: versionId,
    });
  }

  async getTriggers(request: SearchRequest = {}): Promise<ApiResponse<ProcessElement[]>> {
    return this.postQuery<ProcessElement[]>(API_ENDPOINTS.PROCESS_ELEMENTS.TRIGGERS, request);
  }

  async getByKey(key: string, versionId: number): Promise<ApiResponse<ProcessElement>> {
    return this.postQuery<ProcessElement>(API_ENDPOINTS.PROCESS_ELEMENTS.BY_KEY, {
      ProcessElementKey: key,
      ProcessThreadVersionID: versionId,
    });
  }
}

export const processElementApiClient = new ProcessElementApiClient();
